<div class="data-schema-list-wrapper">
    <div *ngFor="let node of nodes">
        <div class="node">
            <nz-tree [nzData]="[node]" nzBlockNode></nz-tree>
        </div>
    </div>
</div>
